export default __webpack_public_path__ + "static/media/v2_hodnota_1.cf7f1a90.svg";